// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_o9-0";
export var buttonContainer = "_o9-3";
export var cancelButton = "_o9-4";
export var headerSection = "_o9-6";
export var headerTitle = "_o9-9";
export var messageSideLeft = "_o9-1";
export var messageSideRight = "_o9-2";
export var orderNumberContainer = "_o9-7";
export var orderNumberLabel = "_o9-8";
export var submitButton = "_o9-5";